const GetDataApi = (form) => {
    let data = {};
    for (var key in form) {
        if (form.hasOwnProperty(key)) {
            data = {
                ...data,
                [form[key].key]: form[key].value
            }
        }
    }
    return data;
}

export default GetDataApi